import { Component, inject, OnInit } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';

import { EbbotChatComponent } from './ebbot-chat/ebbot-chat.component';
import { FeedbackWidgetComponent } from './feedback-widget/feedback-widget.component';
import { DatadogRUMService } from './services/datadog-rum.service';
import { SidenavComponent } from './sidenav/sidenav.component';

@Component({
  imports: [
    RouterModule,
    MatSidenavModule,
    SidenavComponent,
    EbbotChatComponent,
    FeedbackWidgetComponent,
  ],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
  private readonly datadogRUMService = inject(DatadogRUMService);

  ngOnInit() {
    this.datadogRUMService.initDatadogRUM();
  }
}
